import React, { useEffect, useState } from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import useAuth from "../../hooks/useAuth";
import useMatricula from "../../hooks/useMatricula";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import { obtenerLabelEtiqueta } from "../../utils/idioma/LabelsIdioma";

import {
  listado_asignaturas_estudiante_sinLoading,
  listado_asignaturas_habilitadasSinLoading,
  listado_grupos_habilitados,
  sesionesHabilitadas,
} from "../../services/procesoMatricula/procesoMatricula";
import { asignar_asignatura_estudiante } from "../../services/Matricula";
import { cGclasificacion } from "../../config/constantes";

const CardHorario = ({ data, index, limitCredito }) => {
  let {
    setIdAsignaturas,
    gruposHabilitados,
    setGruposHabilitados,
    obtenerDatosEstudiante,
    setListadoAsignaturas,
    multifranjas
  } = useMatricula();
  let {
    setListEventos,
    listEventos,
    setListAsignaturasAgregadas,
    listAsignaturasAgregadas,
    setErrorCursoServices,
    setLoading,
    setListadoAsignaturasEstudiante,
  } = useProcesoMatricula();
  //idioma
  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const { gclasificacion } = obtenerDatosEstudiante || {};
  let horasCount = 0;
  let countC = 0;
  let countE = 0;
  let countO = 0;
  let creditosCount = 0;
  let arrayCGclasificacion = cGclasificacion.split(",");


  let oneDay, twoDay, startTime, endTime, threeHours, fourHours;

  const formatterDate = (dateToFormatter) => {
    let dateResolve = new Date(dateToFormatter);
    dateResolve = `${dateResolve.getDate()}/${dateResolve.getMonth() + 1 < 10
      ? "0" + (Number(dateResolve.getMonth()) + 1)
      : Number(dateResolve.getMonth()) + 1
      }/${dateResolve.getFullYear()}`;
    return dateResolve;
  };

  function sumarDiasFinFullCalendar(fecha, dias) {
    let dataFinal = new Date(fecha).setDate(new Date(fecha).getDate() + dias);
    return dataFinal;
  }

  const formatHora = (fechaEntrada) => {
    const fecha = new Date(fechaEntrada);
    const hora = fecha.getHours().toString().padStart(2, '0');
    const minutos = fecha.getMinutes().toString().padStart(2, '0');

    const horaFormateada = `${hora}:${minutos}`;

    return horaFormateada;
  }
  function restarDiasFinFullCalendar(fecha, dias) {
    let dataFinal = new Date(fecha).setDate(new Date(fecha).getDate() - dias);

    return new Date(dataFinal).toISOString();
  }

  const pushEventos = (data) => {

    const handleAddEventRangoFecha = (listado, listevents) => {
      let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;
      let descritions = `<ul>
      <li>Equivalente: <strong>${listado.dequivalente}</strong> </li>  
      <li>Grupo: <strong> ${listado.sgrupo}</strong></li>
      <li>Modalidad:<strong> ${listado.dmodalidad}
      </strong></li>
      <li>Horario: <strong>${listado.dhorario
        }</strong></li><li>Inicio: <strong>${formatterDate(
          listado.finicio
        )}</strong> </li><li >Fin: <strong>${formatterDate(
          listado.ffin
        )}</strong> </li> <li >Docente: <strong>${listado.ddocente
        }</strong> </li><li >Créditos: <strong>${listado.ncredito}</strong> </li>  
      </ul>   
      `;
      let evento1 = {
        id: codigoUnico,
        title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
        description: descritions,
        startRecur: listado.hinicio,
        endRecur: new Date(sumarDiasFinFullCalendar(listado.hfinal, 1)),
        startTime: formatHora(listado.hinicio),
        endTime: formatHora(listado.hfinal),
        daysOfWeek: [listado.ndia],
      };

      listevents.push(evento1);



    };
    const validarDelMismoDia = (fechaInicio, fechaFin) => {
      const fecha1 = new Date(fechaInicio);
      const fecha2 = new Date(fechaFin);

      const esMismoDia =
        fecha1.getDate() === fecha2.getDate() &&
        fecha1.getMonth() === fecha2.getMonth() &&
        fecha1.getFullYear() === fecha2.getFullYear();


      return esMismoDia;
    };


    let dataEventos = [];


    data.forEach((listado) => {
      if (validarDelMismoDia(listado.hinicio, listado.hfinal) && listado.nhoras > 0) {
        let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;

        let descritions = `<ul><li>Equivalente: <strong> ${listado.dequivalente
          }
          </strong></li>
          <li>Grupo:<strong> ${listado.sgrupo}
          </strong></li>
          <li>Modalidad:<strong> ${listado.dmodalidad}
          </strong></li>
          <li>Horario: <strong>${listado.dhorario
          }</strong></li><li>Inicio: <strong>${formatterDate(
            listado.finicio
          )}</strong> </li><li >Fin: <strong>${formatterDate(
            listado.ffin
          )}</strong> </li> <li >Docente: <strong>${listado.ddocente
          }</strong> </li><li >Créditos: <strong>${listado.ncredito
          }</strong> </li></ul>`;
        let evento;

        evento = {
          id: codigoUnico,
          title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
          description: descritions,
          start: listado.hinicio,
          end: listado.hfinal,
        };



        dataEventos.push(evento);

      }
    });
    data.forEach((listado) => {
      if (!validarDelMismoDia(listado.hinicio, listado.hfinal) && listado.nhoras > 0) {

        handleAddEventRangoFecha(listado, dataEventos);
      }

      if (!validarDelMismoDia(listado.hinicio, listado.hfinal) && listado.nhoras === 0) {


        let codigoUnico = `${listado.sgrupo}|${listado.casignatura}|${listado.cgrupo}`;
        let descritions = `<ul><li>Equivalente: <strong> ${listado.dequivalente
          }
          </strong></li>
          <li>Grupo:<strong> ${listado.sgrupo}
          </strong></li>
          <li>Modalidad:<strong> ${listado.dmodalidad}
          </strong></li>
          <li>Horario: <strong>${listado.dhorario
          }</strong></li><li>Inicio: <strong>${formatterDate(
            listado.finicio
          )}</strong> </li><li >Fin: <strong>${formatterDate(
            listado.ffin
          )}</strong> </li> <li >Docente: <strong>${listado.ddocente
          }</strong> </li><li >Créditos: <strong>${listado.ncredito
          }</strong> </li></ul>`;


        let evento;
        evento = {
          id: codigoUnico,
          title: `<span>${listado.dcurso}</span> <br><strong>${listado.sgrupo}</strong>`,
          description: descritions,
          start: listado.hinicio,
          end: listado.hfinal,
          allDay: true,
        };
        dataEventos.push(evento);

      }
    });

    setListEventos(dataEventos);
    //Array evento
  };

  const handleAddEvents = async () => {


    const listSesiones = async () => {
      try {
        setLoading(true);
        let data = await sesionesHabilitadas(obtenerDatosEstudiante);
        pushEventos(data);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    await listSesiones();
  };

  const handleAddRow = (
    codigo,
    asignatura,
    tipoAsignatura,
    creditos,
    horas,
    horario,
    inicio,
    fin,
    docente,
    ciclo,
    sumilla,
    vez,
    ccarrera,
    casignatura,
    cgrupo,
    dtipo,
    ccurso,
    ssgrupo,
    ccurso_origen,
    ccurso_equivalente,
    dmodalidad,
    gmodalidad
  ) => {
    const newRow = {
      scurso: codigo,
      sgrupo: ssgrupo,
      dcurso: asignatura,
      gtipo: tipoAsignatura,
      ncreditos: creditos,
      nhoras: horas,
      dhorario: horario,
      finicio: inicio,
      ffin: fin,
      ddocente: docente,
      cciclo: ciclo,
      dsumilla: sumilla,
      nveces: vez,
      ccarrera: ccarrera,
      casignatura: casignatura,
      cgrupo: cgrupo,
      ctipo: dtipo,
      ccurso: ccurso,
      ccurso_origen,
      ccurso_equivalente,
      dmodalidad,
      gmodalidad,
    };
    setListAsignaturasAgregadas([...listAsignaturasAgregadas, newRow]);
  };

  const AgregarAsignatura = async (
    sgrupos,
    casignaturas,
    cgrupos,
    listado,
    tipo
  ) => {

    let inicio = formatterDate(listado.finicio);

    let fin = formatterDate(listado.ffin);
    let codigoUnico = `${sgrupos}|${casignaturas}|${cgrupos}`;
    let estadoBoton = botonHabilitado(codigoUnico);


    if (tipo == "agregar") {
      let splitHorario = listado.dhorario.split(" ");

      let eventoDia = filtrarDia(splitHorario[0]);
      let eventoHoraInicio = splitHorario[1];
      let eventoHoraFin = splitHorario[3];

      let eventoDia2 = filtrarDia(splitHorario[4]);
      let eventoHoraInicio2 = splitHorario[5];
      let eventoHoraFin2 = splitHorario[7];

      let splitHoraios = listado.dhorario.split(",");

      let formatHorario = splitHoraios.map((data, index) => {
        let sp = data.split(" ");

        let objHorario;
        if (index == 0) {
          objHorario = {
            eventoDia: filtrarDia(sp[0]),
            eventoHoraInicio: sp[1],
            eventoHoraFin: sp[3],
          };
        } else {
          objHorario = {
            eventoDia: filtrarDia(sp[1]),
            eventoHoraInicio: sp[2],
            eventoHoraFin: sp[4],
          };
        }
        return objHorario;
      });


      let modal = document.querySelector("#bntCruce");
      let modalErrorAsignatura = document.querySelector("#errorAsignatura");

      let parametrosArmarCadena = {
        scurso: listado.scurso,
        sgrupo: listado.sgrupo,
        dcurso: listado.dcurso,
        gtipo: listado.stipo,
        ncreditos: listado.ncredito,
        nhoras: listado.nhoras,
        dhorario: listado.dhorario,
        finicio: inicio,
        ffin: fin,
        ddocente: listado.ddocente,
        cciclo: listado.cciclo,
        dsumilla: listado.dsumilla,
        nveces: listado.nveces,
        ccarrera: listado.ccarrera,
        casignatura: listado.casignatura,
        cgrupo: listado.cgrupo,
        ctipo: listado.dtipo,
        ccurso: listado.ccurso,
        ccurso_origen: listado.ccurso_origen,
        ccurso_equivalente: listado.ccurso_equivalente,
      };

      let dataEnviar = {
        casignatura: listado.casignatura,
        cgrupo: listado.cgrupo,
        nvez: listado.nveces,
        cadena_asignaturas: strArmarCadenaIns(parametrosArmarCadena),
        agregado: 1,
        sequivalente: listado.sequivalente,
        scurso: listado.scurso,
        sgrupo: listado.sgrupo,
        ccurso_origen: Number(listado.ccurso_origen),
        ccurso_equivalente: Number(listado.ccurso_equivalente),
      };
      try {
        setLoading(true);

        let asignarAsignatura = await asignar_asignatura_estudiante(
          obtenerDatosEstudiante,
          dataEnviar
        );
        if (
          asignarAsignatura.Code == 1 &&
          asignarAsignatura.StatusCode == 200
        ) {

          let respuestaAsignatura = await listado_asignaturas_habilitadasSinLoading(obtenerDatosEstudiante);
          setListadoAsignaturas(respuestaAsignatura)


          await listado_grupos_habilitados(
            obtenerDatosEstudiante,
            setGruposHabilitados
          );

          await listado_asignaturas_estudiante_sinLoading(
            obtenerDatosEstudiante,
            setListadoAsignaturasEstudiante
          );
          await handleAddEvents();
        } else {
          if (asignarAsignatura.Message) {
            setErrorCursoServices(asignarAsignatura.Message);
            modalErrorAsignatura.click();
          }
        }
      } catch (error) {
        setErrorCursoServices(error);
        modalErrorAsignatura.click();
        setLoading(false);
      } finally {
        setLoading(false);
      }
    } else {
      let modalErrorAsignatura = document.querySelector("#errorAsignatura");

      let parametrosArmarCadena = {
        scurso: listado.scurso,
        sgrupo: listado.sgrupo,
        dcurso: listado.dcurso,
        gtipo: listado.stipo,
        ncreditos: listado.ncredito,
        nhoras: listado.nhoras,
        dhorario: listado.dhorario,
        finicio: inicio,
        ffin: fin,
        ddocente: listado.ddocente,
        cciclo: listado.cciclo,
        dsumilla: listado.dsumilla,
        nveces: listado.nveces,
        ccarrera: listado.ccarrera,
        casignatura: listado.casignatura,
        cgrupo: listado.cgrupo,
        ctipo: listado.dtipo,
        ccurso: listado.ccurso,
        ccurso_origen: listado.ccurso_origen,
        ccurso_equivalente: listado.ccurso_equivalente,
      };

      let dataEliminar = {
        casignatura: listado.casignatura,
        cgrupo: listado.cgrupo,
        nvez: listado.nveces,
        cadena_asignaturas: strArmarCadenaDel(parametrosArmarCadena),
        agregado: 2,
        sequivalente: listado.sequivalente,
        scurso: listado.scurso,
        sgrupo: listado.sgrupo,
        ccurso_origen: Number(listado.ccurso_origen),
        ccurso_equivalente: Number(listado.ccurso_equivalente),
      };

      try {
        setLoading(true);

        let asignarAsignatura = await asignar_asignatura_estudiante(
          obtenerDatosEstudiante,
          dataEliminar
        );
        if (
          asignarAsignatura.Code == 1 &&
          asignarAsignatura.StatusCode == 200
        ) {

          let respuestaAsignatura = await listado_asignaturas_habilitadasSinLoading(obtenerDatosEstudiante);
          setListadoAsignaturas(respuestaAsignatura)

          await listado_grupos_habilitados(
            obtenerDatosEstudiante,
            setGruposHabilitados
          );

          await listado_asignaturas_estudiante_sinLoading(
            obtenerDatosEstudiante,
            setListadoAsignaturasEstudiante
          );
          await handleAddEvents();
        } else {
          setErrorCursoServices(asignarAsignatura.Message);
          modalErrorAsignatura.click();
        }
      } catch (error) {
        setErrorCursoServices(error);
        modalErrorAsignatura.click();
        setLoading(false);
      } finally {
        setLoading(false);
      }

    }
  };

  const strArmarCadenaIns = (crearCadena) => {
    let casignaturaIns;

    let copialistaAsignatura = [...listAsignaturasAgregadas, crearCadena];

    copialistaAsignatura.map((e, index) => {

      if (index === 0) {
        casignaturaIns =
          e.casignatura +
          "," +
          e.cgrupo +
          "," +
          e.nveces +
          "," +
          e.ccurso_origen +
          "," +
          e.ccurso_equivalente;
      } else {
        casignaturaIns +=
          "|" +
          e.casignatura +
          "," +
          e.cgrupo +
          "," +
          e.nveces +
          "," +
          e.ccurso_origen +
          "," +
          e.ccurso_equivalente;
      }
    });
    return casignaturaIns;
  };

  const strArmarCadenaDel = (elim) => {
    let count = 0;
    let listaAgregados = [...listAsignaturasAgregadas];

    let eliminados1 = listaAgregados.filter((lisA) => {
      if (
        lisA?.casignatura !== elim?.casignatura &&
        lisA?.cgrupo !== elim?.cgrupo
      ) {
        return lisA;
      }
    });

    let casignaturaDel1 = "";
    eliminados1.forEach((e) => {


      if (count === 0) {
        casignaturaDel1 =
          e?.casignatura +
          "," +
          e?.cgrupo +
          "," +
          e?.nveces +
          "," +
          e.ccurso_origen +
          "," +
          e.ccurso_equivalente;
      } else {
        casignaturaDel1 +=
          "|" +
          e?.casignatura +
          "," +
          e?.cgrupo +
          "," +
          e?.nveces +
          "," +
          e.ccurso_origen +
          "," +
          e.ccurso_equivalente;
      }

      count++;
    });
    return casignaturaDel1;
  };

  const botonEliminar = (
    basignadoss,
    scursoss,
    ncuposs,
    sgruposs,
    sequivalente,
    cgrupo
  ) => {
    let asignados = gruposHabilitados.filter((e) => {
      return e.scurso == scursoss && e.basignado == true;
    });
    return arrayCGclasificacion.includes(String(gclasificacion))
      ? false
      : asignados.some(
        (e) =>
          e.cgrupo == cgrupo &&
          e.sgrupo == sgruposs &&
          e.basignado == basignadoss &&
          e.sequivalente == sequivalente
      );
  };

  const botonHabilitado = (
    basignadoss,
    scursoss,
    ncuposs,
    sgruposs,
    sequivalente,
    cgrupo,
    bcruce
  ) => {

    if(bcruce == true ) {
      return false;
    }

    let asignados = gruposHabilitados.filter((e) => {
      return e.scurso == scursoss && e.basignado == true;
    });

    let asignados2 = gruposHabilitados.filter((e) => {
      if (
        e.cgrupo == cgrupo &&
        e.sgrupo == sgruposs &&
        e.sequivalente == sequivalente &&
        e.sgrupo == sgruposs &&
        e.basignado == false &&
        e.ncupos <= 0
      ) {
        return e;
      }
    });

    if (arrayCGclasificacion.includes(String(gclasificacion))) {
      return false;
    }
    if (asignados.length > 0) {
      return false;
    }
    if (asignados2.length > 0) {
      return false;
    }
    return true;
  };

  const botonBloqueado = (
    basignadoss,
    scursos,
    ncuposs,
    sgrupos,
    sequivalente,
    cgrupo,
    bcruce
  ) => {
    // Si que existe una basignatura en true entonces deshabilitar todos los botones del grupo de la asignatura

    if( bcruce == true) {
      return true;
    }

    let asignados = gruposHabilitados.filter((e) => {
      return e.scurso == scursos && e.basignado == true;
    });

    let asignados2 = gruposHabilitados.filter((e) => {
      if (
        (e.cgrupo == cgrupo &&
        e.sgrupo == sgrupos &&
        e.sequivalente == sequivalente &&
        e.sgrupo == sgrupos &&
        e.basignado == false &&
        e.ncupos <= 0)
      ) {
        return e;
      }
    });

    if (arrayCGclasificacion.includes(String(gclasificacion))) {
      return true;
    }
    if (asignados.length > 0) {
      if (
        asignados.some(
          (e) =>
            e.cgrupo == cgrupo &&
            e.scurso == scursos &&
            e.sequivalente == sequivalente &&
            e.sgrupo == sgrupos
        )
      ) {
        return false;
      } else {
        return true;
      }
    }

    if (asignados2.length > 0) {
      return true;
    }
    return false;
  };

  const cruceDeHorario = (cruceDeHorario, fecha) => {
    let { inicio, fin } = fecha;
    let arrayInicio = cruceDeHorario.map((data) => {
      let hora1Milisegundo = conversionMilisegundos(
        data.eventoHoraInicio.split(":")[0],
        data.eventoHoraInicio.split(":")[1]
      );
      let hora1FinMilisegundo = conversionMilisegundos(
        data.eventoHoraFin.split(":")[0],
        data.eventoHoraFin.split(":")[1]
      );

      let dataRetorna = {
        dia: data.eventoDia,
        horaIni: hora1Milisegundo,
        horaFin: hora1FinMilisegundo,
      };

      return dataRetorna;
    });

    let newEvents = listEventos.map((list) => {
      let dataGlo = arrayInicio.map((array) => {
        const evaluar1 = new Date(inicio)?.toISOString();
        const evaluar2 = new Date(fin)?.toISOString();
        const inicio2 = new Date(list.startRecur)?.toISOString();
        const fin2 = new Date(
          restarDiasFinFullCalendar(list?.endRecur, 1)
        )?.toISOString();
        if (
          (inicio2 <= evaluar2 && evaluar1 <= fin2) ||
          (evaluar1 <= fin2 && inicio2 <= evaluar2)
        ) {
          if (list.daysOfWeek[0] == array.dia) {
            let startTime1 = conversionMilisegundos(
              list.startTime.split(":")[0],
              list.startTime.split(":")[1].replace(",", "")
            );
            let endTime1 = conversionMilisegundos(
              list.endTime.split(":")[0],
              list.endTime.split(":")[1].replace(",", "")
            );
            const evaluar3 = array.horaIni;
            const evaluar4 = array.horaFin;
            const inicio3 = startTime1;
            const fin3 = endTime1;
            if (
              (inicio3 < evaluar4 && evaluar3 < fin3) ||
              (evaluar3 < fin3 && inicio3 < evaluar4)
            ) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      });
      let resultado = dataGlo.includes(true) ? true : false;
      return resultado;
    });

    let resultado = newEvents.includes(true) ? true : false;
    return resultado;
  };

  const conversionMilisegundos = (hora, minuto) => {
    let minutos = minuto == "00" ? 0 : minuto;
    let min = String(minutos).replace(",", "");
    let milHora = Number(hora) * 3600000;
    let milMinutos = Number(min) * 60000;
    let totalMilisegundos = milHora + milMinutos;
    return totalMilisegundos;
  };

  const removeRow = (ccurso, cgrupo) => {
    const newRow = listAsignaturasAgregadas.filter(
      (data) => data.ccurso !== ccurso && data.cgrupo !== cgrupo
    );
    setListAsignaturasAgregadas(newRow);
  };
  const removerAsignatura = (id) => {
    const newEvents = listEventos.filter(
      (listEventos) => listEventos.id !== id
    );
    setListEventos(newEvents);
  };

  let filtrarDia = (dia) => {
    switch (dia) {
      case "Lu":
        return 1;
        break;
      case "Ma":
        return 2;
        break;
      case "Mi":
        return 3;
        break;
      case "Ju":
        return 4;
        break;
      case "Vi":
        return 5;
        break;
      case "Sá":
        return 6;
        break;
      default:
        break;
    }
  };

  listAsignaturasAgregadas.map((data) => {
    if (data?.gtipo === "C") {
      countC++;
    }
    if (data?.gtipo === "E") {
      countE++;
    }
    if (data?.gtipo === "O") {
      countO++;
    }
    let creditos = data?.ncreditos;
    creditosCount = creditosCount + creditos;
    let horas = data?.nhoras;
    horasCount = horasCount + horas;
  });

  let hash2 = {};
  let validarCantidadDegruposxAsignatura = (scurso, sequivalente) => {
    let cantidad = gruposHabilitados.filter((datas, index3) => {
      if (datas.scurso == scurso) {
        return data;
      }
    });

    let validarDuplicidadAcordion = gruposHabilitados.some((d) => {
      if (d.scurso === scurso) {
        if (hash2[d.sequivalente]) {
          return false;
        } else {
          return (hash2[d.sequivalente] = true);
        }
      }
    });

    const busqueda = gruposHabilitados.reduce((acc, grupos) => {
      acc[grupos.sequivalente] = ++acc[grupos.sequivalente] || 0;
      return acc;
    }, {});

    const duplicados = gruposHabilitados.filter((grupos) => {
      if (grupos.scurso == scurso) {
        return busqueda[grupos.sequivalente];
      }
    });

    let cantidadEquivalente = gruposHabilitados.filter(
      (d) => d.scurso === scurso && d.sequivalente === sequivalente
    );

    let indexGeneralMap = [];
    let ObtenerElUltimoIndex = [];
    if (validarDuplicidadAcordion) {
      let nuevoIndex = gruposHabilitados.map((datas, index3) => {
        if (datas.scurso == scurso) {
          //Si es mayor que uno es porque existe mas de un equivalente

          if (ObtenerElUltimoIndex.includes(datas.sequivalente)) {
          } else {
            ObtenerElUltimoIndex = [
              ...ObtenerElUltimoIndex,
              datas.sequivalente,
            ];
            return {
              ccurso: datas.ccurso,
              scurso: datas.scurso,
              dcurso: datas.dcurso,
              sequivalente: datas.sequivalente,
              dequivalente: datas.dequivalente,
              newIndex: ObtenerElUltimoIndex.indexOf(datas.sequivalente),
            };
          }
        }
      });

      indexGeneralMap = nuevoIndex.filter((e) => e !== undefined);
    } else {
      let gruposNormales = gruposHabilitados.map((datas, index) => {
        if (datas.scurso == scurso) {
          if (ObtenerElUltimoIndex.includes(datas.sequivalente)) {
          } else {
            ObtenerElUltimoIndex = [
              ...ObtenerElUltimoIndex,
              datas.sequivalente,
            ];
            return {
              ccurso: datas.ccurso,
              scurso: datas.scurso,
              dcurso: datas.dcurso,
              sequivalente: datas.sequivalente,
              dequivalente: datas.dequivalente,
              newIndex: ObtenerElUltimoIndex.indexOf(datas.sequivalente),
            };
          }
        }
      });

      indexGeneralMap = gruposNormales.filter((datas) => datas !== undefined);
    }

    let ee = indexGeneralMap.filter((e) => e.sequivalente == sequivalente);

    return ee[0]?.newIndex;
  };

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        global_grupo: obtenerLabelEtiqueta(
          "lbl_global_grupo",
          listadoEtiquetas
        ),
        global_docente: obtenerLabelEtiqueta(
          "lbl_global_docente",
          listadoEtiquetas
        ),
        horario_cupos: obtenerLabelEtiqueta(
          "lbl_horario_cupos",
          listadoEtiquetas
        ),
        global_horario: obtenerLabelEtiqueta(
          "lbl_global_horario",
          listadoEtiquetas
        ),
        global_inicio: obtenerLabelEtiqueta(
          "lbl_global_inicio",
          listadoEtiquetas
        ),
        global_fin: obtenerLabelEtiqueta("lbl_global_fin", listadoEtiquetas),
        global_cred: obtenerLabelEtiqueta("lbl_global_cred", listadoEtiquetas),
        global_vez: obtenerLabelEtiqueta("lbl_global_vez", listadoEtiquetas),
        horario_unidades: obtenerLabelEtiqueta(
          "lbl_horario_unidades",
          listadoEtiquetas
        ),
        global_ciclo: obtenerLabelEtiqueta(
          "lbl_global_ciclo",
          listadoEtiquetas
        ),
        global_tutor: obtenerLabelEtiqueta(
          "lbl_global_tutor",
          listadoEtiquetas
        ),
        horario_equiv: obtenerLabelEtiqueta(
          "lbl_horario_equiv",
          listadoEtiquetas
        ),
        global_sumilla: obtenerLabelEtiqueta(
          "lbl_global_sumilla",
          listadoEtiquetas
        ),
        horario_agregar_asignatura: obtenerLabelEtiqueta(
          "lbl_horario_agregar_asignatura",
          listadoEtiquetas
        ),
        horario_quitar_asignatura: obtenerLabelEtiqueta(
          "lbl_horario_quitar_asignatura",
          listadoEtiquetas
        ),
        lbl_horario_cruce: obtenerLabelEtiqueta(
          "lbl_horario_cruce",
          listadoEtiquetas
        ),
        lbl_horario_msj_cruce: obtenerLabelEtiqueta(
          "lbl_horario_msj_cruce",
          listadoEtiquetas
        ),
        lbl_horario_limite_creditos: obtenerLabelEtiqueta(
          "lbl_horario_limite_creditos",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);
  const {
    global_grupo,
    global_docente,
    horario_cupos,
    global_horario,
    global_inicio,
    global_fin,
    global_cred,
    global_vez,
    horario_unidades,
    global_ciclo,
    horario_equiv,
    global_sumilla,
    horario_agregar_asignatura,
    horario_quitar_asignatura
  } = etiquetas;

  return (
    <div className="accordion-item" style={{ display: "block" }}>
      <h2 className="accordion-header" id={index}>
        <button
          className={`${data?.binscrito ? 'course-info-3 course-selected ' : ''} accordion-button collapsed`}
          type="button"
          data-bs-toggle="collapse"
          data-bs-target={`#C${index}`}
          aria-expanded="false"
          aria-controls={`C${index}`}
        >
          <p className="mb-0 text-uppercase w-40"><span className="text-uppercase fw-bolder w-50">{data?.nombreAsignatura?.split("-")[0]} </span> - {data?.nombreAsignatura?.split("-")[1]}</p>

          {
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip id={data?.stipo}>{data?.dtipo}</Tooltip>}
            >
              <span
                className={`
                fs-sm 
                ${data?.stipo === "C"
                    ? "icon-com"
                    : data?.stipo === "E"
                      ? "icon-ele"
                      : data?.stipo === "O"
                        ? "icon-obli"
                        : ""
                  }`}
                style={{ width: '20px' }}
              >
                <span style={{ top: "6px", width: '25px' }} variant="secondary">
                  {data?.stipo}
                </span>{" "}
              </span>
            </OverlayTrigger>
          }

        </button>
        <div className="w-100 d-flex justify-content-between py-2 px-3 border-top" style={{ fontSize: "12px" }} >
          <div><strong>Nivel:</strong> {" "}{data?.equivalentes[0]?.ItemsEqui[0]?.f?.cciclo}</div>

          <div><strong>Vez:</strong> {" "}{data?.equivalentes[0]?.ItemsEqui[0]?.f?.nveces}</div>

          <div><strong>Crédito:</strong> {" "}{data?.equivalentes[0]?.ItemsEqui[0]?.f?.ncredito}</div>
        </div>
      </h2>

      {data?.equivalentes?.map((datas2, index2) => {
        return (
          <div
            key={index2}
            id={`C${index}`}
            className="accordion-collapse collapse"
            aria-labelledby={index}
          >
            <div className="accordion-body">
              {datas2?.ItemsEqui?.map((datas) => {

                let cuposDisponibles;
                const isEstudianteDurin = datas?.f?.gdurin == 1;

                if (isEstudianteDurin) {
                  cuposDisponibles = Math.max(0, (datas?.f?.ncupodurin || 0) - (datas?.f?.ninscritodurin || 0));
                } else {
                  cuposDisponibles = Math.max(0, (datas?.f?.ncupos || 0) - ((datas?.f?.ncupodurin || 0)
                                               + (datas?.f?.nreservado || 0) + (datas?.f?.ninscrito || 0)));
                }


                return (
                  <div
                    key={`${datas?.f?.ccurso + datas?.f?.cgrupo}`.toString()}
                    className="group"
                  >
                    <div className="title-group d-flex justify-content-between">
                      <p className="fw-medium mb-0">
                        {global_grupo} <span>{datas?.f?.sgrupo}</span>
                      </p>
                      <p className=" mb-0">
                        {global_docente}:{" "}
                        <span className="fw-medium">{datas?.f?.ddocente}</span>{" "}
                      </p>
                      <p className=" mb-0">
                        {horario_cupos}:{" "}
                        <span className="fw-medium">{cuposDisponibles}</span>
                      </p>
                    </div>

                    <div
                      className={`item-group ${(validarCantidadDegruposxAsignatura(
                        datas?.f?.scurso,
                        datas?.f?.sequivalente
                      ) +
                        1) %
                        2 ==
                        0
                        ? "background-equivalente"
                        : ""
                        }`}
                    >
                      <div className="d-flex">
                        <p className="mb-0">
                          {global_horario}:{" "}
                          <span className="fw-medium">
                            {datas?.f?.dhorario}
                          </span>
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="mb-0 me-2">
                          {global_inicio}:{" "}
                          <span className="fw-medium">
                            {formatterDate(datas?.f?.finicio)}{" "}
                          </span>{" "}
                        </p>
                        <p className="mb-0">
                          {global_fin}:{" "}
                          <span className="fw-medium">
                            {" "}
                            {formatterDate(datas?.f?.ffin)}{" "}
                          </span>
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="mb-0 me-2">
                          {global_cred}:{" "}
                          <span className="fw-medium">
                            {datas?.f?.ncredito}
                          </span>{" "}
                        </p>
                        <p className="mb-0 me-2">
                          {global_vez}:{" "}
                          <span className="fw-medium">{datas?.f?.nveces}</span>{" "}
                        </p>
                        <p className="mb-0 me-2">
                          {horario_unidades}:{" "}
                          <span className="fw-medium">
                            {datas?.f?.nunidades}
                          </span>
                        </p>
                        <p className="mb-0 me-2">
                          {global_ciclo}:{" "}
                          <span className="fw-medium">{datas?.f?.cciclo}</span>
                        </p>
                      </div>
                      <div className="d-flex justify-content-between">
                        <p className="mb-0 me-2">
                          {horario_equiv}:
                          <span className="fw-medium">
                            {" "}
                            {datas?.f?.dequivalente}
                          </span>{" "}
                        </p>
                        <div className="d-flex">
                          <p className="mb-0">{global_sumilla}: </p>

                          <button
                            className="btn btn-sumilla"
                            data-bs-toggle="modal"
                            data-bs-target="#sumilla"
                            onClick={() => {
                              setIdAsignaturas(datas?.f?.scurso);
                            }}
                          >
                            <svg
                              width="13"
                              height="13"
                              viewBox="0 0 13 13"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M6.01675 4.71675H7.31675V3.41675H6.01675M6.66675 11.8667C3.80025 11.8667 1.46675 9.53325 1.46675 6.66675C1.46675 3.80025 3.80025 1.46675 6.66675 1.46675C9.53325 1.46675 11.8667 3.80025 11.8667 6.66675C11.8667 9.53325 9.53325 11.8667 6.66675 11.8667ZM6.66675 0.166748C5.81316 0.166748 4.96792 0.334876 4.17931 0.661531C3.39069 0.988187 2.67413 1.46697 2.07055 2.07055C0.851567 3.28954 0.166748 4.94284 0.166748 6.66675C0.166748 8.39065 0.851567 10.044 2.07055 11.2629C2.67413 11.8665 3.39069 12.3453 4.17931 12.672C4.96792 12.9986 5.81316 13.1667 6.66675 13.1667C8.39065 13.1667 10.044 12.4819 11.2629 11.2629C12.4819 10.044 13.1667 8.39065 13.1667 6.66675C13.1667 5.81316 12.9986 4.96792 12.672 4.17931C12.3453 3.39069 11.8665 2.67413 11.2629 2.07055C10.6594 1.46697 9.94281 0.988187 9.15419 0.661531C8.36557 0.334876 7.52034 0.166748 6.66675 0.166748M6.01675 9.91675H7.31675V6.01675H6.01675V9.91675Z"
                                fill="#FFC702"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                      <div className="d-flex gap-2 align-items-center mt-3">
                        <button
                          id="bntCruce"
                          data-bs-toggle="modal"
                          data-bs-target="#cruce"
                          style={{ display: "none" }}
                        ></button>
                        <button
                          type="button"
                          className="btn btn-outline-info rounded-3 p-1 px-3 fs-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#errorCurso"
                          style={{ display: "none" }}
                          id="errorAsignatura"
                        ></button>



                        {/* boton de Agregar */}
                        {botonHabilitado(
                          datas?.f?.basignado,
                          datas?.f?.scurso,
                          datas?.f?.ncupos,
                          datas?.f?.sgrupo,
                          datas?.f?.sequivalente,
                          datas?.f?.cgrupo,
                          datas?.f?.bcruce,
                        ) && (
                            <button
                              id="agregar"
                              className={`btn   btn-outline-info
                                  rounded-3 p-1 px-3 fs-sm`}
                              onClick={() => {
                                AgregarAsignatura(
                                  datas?.f?.sgrupo,
                                  datas?.f?.casignatura,
                                  datas?.f?.cgrupo,
                                  datas?.f,
                                  "agregar"
                                );
                              }}
                              disabled={multifranjas}
                            >
                              {horario_agregar_asignatura}
                            </button>
                          )}

                        {/* boton de eliminar */}

                        {botonEliminar(
                          datas?.f?.basignado,
                          datas?.f?.scurso,
                          datas?.f?.ncupos,
                          datas?.f?.sgrupo,
                          datas?.f?.sequivalente,
                          datas?.f?.cgrupo
                        ) && (
                            <button
                              id="agregar"
                              className={`btn btn-outline-danger
                                   rounded-3 p-1 px-3 fs-sm`}
                              onClick={() => {
                                AgregarAsignatura(
                                  datas?.f?.sgrupo,
                                  datas?.f?.casignatura,
                                  datas?.f?.cgrupo,
                                  datas?.f,
                                  "eliminar"
                                );
                              }}
                              disabled={multifranjas}
                            >
                              <i className="far fa-trash me-2"></i>{" "}
                              {horario_quitar_asignatura}
                            </button>
                          )}

                        {/* boton de Bloqueado */}
                        {botonBloqueado(
                          datas?.f.basignado,
                          datas?.f.scurso,
                          datas?.f.ncupos,
                          datas?.f.sgrupo,
                          datas?.f?.sequivalente,
                          datas?.f?.cgrupo,
                          datas?.f?.bcruce,
                        ) && (
                            <button
                              className={`btn btn-outline-secondary rounded-3 p-1 px-3 fs-sm`}
                              disabled={true}
                            >
                              {horario_agregar_asignatura}
                            </button>
                          )}

                        {/* CNSO - REQ 14 */}
                        {datas?.f?.bcruce === true && (
                          <>
                            <span className="text-orange-900 fw-normal"> Cruce de horario </span>
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Tooltip className="tooltip-all">
                                  <span style={{ color: '#f58d05ff' }}><span className="fw-bold">CRUCE: </span>{datas?.f?.dcruce || "Cruce de horario detectado"}</span>
                                </Tooltip>
                              }
                            >
                              <i
                                className="bi bi-exclamation-triangle-fill"
                                style={{ color: "#ff9800", fontSize: "1.1rem", cursor: "pointer" }}
                              ></i>
                            </OverlayTrigger>
                          </>
                        )
                        }
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CardHorario;
